/**
 * Provides routes
 */
export enum Routes {
  HOME = '/',
  BLOG = '/blog',
  BUILDING_INSURANCE = '/building-insurance',
  BUILDING_VALUE_CALCULATOR = '/building-insurance/calculator',
  BASKET = '/basket',
  CAR_INSURANCE = '/car-insurance',
  PET_INSURANCE = '/pet-insurance',
  Checkout = '/checkout',
  CHOOSE_PRODUCT = '/choose-product',
  CONFLICT_OF_INTEREST_MANAGEMENT = '/legal/conflict-of-interest-management',
  COMPLAINTS_RESOLUTION = '/legal/complaints-resolution',
  CONTACT_US = '/contact-us',
  COVER_ACTIVE = '/cover-active',
  CUSTOMER_DETAILS = '/customer-details',
  CAREERS_AT_NAKED = '/careers-at-naked',
  Difference = '/naked-difference',
  ENCYCLOPAEDIA = '/definitions',
  FAQ = '/frequently-asked-questions/the-basics',
  Fulfillment = '/fulfillment',
  HOME_CONTENTS_INSURANCE = '/home-contents-insurance',
  MULTI_CTA = '/choose-product?stage=main',
  MULTI_CTA_SINGLE_ITEM_TYPE = '/choose-product?stage=single-item-type',
  MULTI_CTA_SINGLE_ITEM_VALUE = '/choose-product?stage=single-item-value',
  NOT_FOUND = '/404',
  PHONE_INSURANCE = '/single-items-insurance/phone',
  PRIVACY_POLICY = '/legal/privacy-policy',
  Quote = '/quote',
  QuoteBuilding = '/quote/building',
  QuoteCar = '/quote/car',
  QuotePet = '/quote/pet',
  QuoteSingleItem = '/choose-product?stage=single-item-type',
  QuoteHousehold = '/quote/household',
  QuoteTowable = '/quote/single-item?type=TOWABLE',
  QuoteItem = '/quote/[itemType]',
  QuoteRenter = '/quote/renter',
  QuoteSingleItemUnderwritten = '/quote/single-item',
  SINGLE_ITEMS_INSURANCE = '/single-items-insurance',
  SINGLE_ITEMS_CONFIRMATION = '/single-items-confirmation',
  Summary = '/summary',
  TERMS_OF_USE = '/legal/terms-of-use',
  USER_EXISTS = '/user-exists',
  THANKS = '/thanks',
  VERIFY_OTP = '/verify-otp',
  GET_NAKED_APP = '/get-naked-app',
  CREATE_ACCOUNT = '/create-account',
  PASSWORD_SIGNUP = '/password-signup',
  CAR_CONTENT_HUB = '/car-insurance/guide',
  ABOUT_US = '/about-us',
}

export type PathNames = {
  [path in Routes]: string;
};

/**
 * Provides named pathname names for analytics and recaptcha purposes
 */
export const PATH_NAMES: PathNames = {
  [Routes.HOME]: 'Home',
  [Routes.BLOG]: 'Blog',
  [Routes.BUILDING_INSURANCE]: 'BuildingInsurance',
  [Routes.CAR_INSURANCE]: 'CarInsurance',
  [Routes.CAR_CONTENT_HUB]: 'CarContentHub',
  [Routes.ABOUT_US]: 'AboutUs',
  [Routes.PET_INSURANCE]: 'PetInsurance',
  [Routes.Checkout]: 'Checkout',
  [Routes.CHOOSE_PRODUCT]: 'ChooseProduct',
  [Routes.CONFLICT_OF_INTEREST_MANAGEMENT]: 'ConflictOfInterestManagement',
  [Routes.COMPLAINTS_RESOLUTION]: 'ComplaintsResolution',
  [Routes.CONTACT_US]: 'ContactUs',
  [Routes.COVER_ACTIVE]: 'CoverActove',
  [Routes.CUSTOMER_DETAILS]: 'CustomerDetails',
  [Routes.CAREERS_AT_NAKED]: 'CareersAtNaked',
  [Routes.Difference]: 'Difference',
  [Routes.ENCYCLOPAEDIA]: 'Encyclopaedia',
  [Routes.FAQ]: 'Faqs',
  [Routes.Fulfillment]: 'Fulfillment',
  [Routes.HOME_CONTENTS_INSURANCE]: 'HomeContentsInsurance',
  [Routes.MULTI_CTA]: 'MultiCta',
  [Routes.MULTI_CTA_SINGLE_ITEM_TYPE]: 'MultiCtaSingleItemType',
  [Routes.MULTI_CTA_SINGLE_ITEM_VALUE]: 'MultiCtaSingleItemValue',
  [Routes.NOT_FOUND]: 'NotFound',
  [Routes.PHONE_INSURANCE]: 'PhoneInsurance',
  [Routes.PRIVACY_POLICY]: 'PrivacyPolicy',
  [Routes.Quote]: 'Quoting',
  [Routes.QuoteBuilding]: 'Quoting',
  [Routes.QuoteCar]: 'Quoting',
  [Routes.QuotePet]: 'Quoting',
  [Routes.QuoteHousehold]: 'Quoting',
  [Routes.QuoteTowable]: 'Quoting',
  [Routes.QuoteItem]: 'CarQuoting',
  [Routes.QuoteRenter]: 'Quoting',
  [Routes.QuoteSingleItemUnderwritten]: 'Quoting',
  [Routes.SINGLE_ITEMS_INSURANCE]: 'SingleItemsInsurance',
  [Routes.SINGLE_ITEMS_CONFIRMATION]: 'SingleItemsConfirmation',
  [Routes.Summary]: 'Summary',
  [Routes.BASKET]: 'Basket',
  [Routes.TERMS_OF_USE]: 'TermsOfUse',
  [Routes.QuoteSingleItem]: 'SingleItemsQuoting',
  [Routes.USER_EXISTS]: 'UserExists',
  [Routes.THANKS]: 'thanks',
  [Routes.VERIFY_OTP]: 'VerifyOtp',
  [Routes.GET_NAKED_APP]: 'GetNakedApp',
  [Routes.CREATE_ACCOUNT]: 'CreateAccount',
  [Routes.PASSWORD_SIGNUP]: 'PasswordSignup',
  [Routes.BUILDING_VALUE_CALCULATOR]: 'BuildingValueCalculator',
};
